module.exports = __webpack_public_path__ + "static/media/ICN_Benefits.ad993ed1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ICN_Benefits.svg
// module id = 163
// module chunks = 0